import { Box, styled } from '@mui/material';

export const ButtonWrap = styled(Box)(() => ({
  width: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const CardBottomButtonsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  borderRadius: '0 0 8px 8px',
  boxShadow: theme.palette.case.shadow.default,
  background: theme.palette.case.neutral.n0,
  minHeight: '54px',
}));

export const MiddleLine = styled(Box)(({ theme }) => ({
  height: '24px',
  width: '1px',
  background: theme.palette.case.neutral.n200,
  alignSelf: 'center',
}));
